import React, {Component} from 'react';
import Dimensions from 'react-dimensions';
import {Table, Column, Cell} from 'fixed-data-table-2';

const BookingCell = ({rowIndex, data, itemName, ...props}) => {
    return (
        <Cell {...props}>
            {data[rowIndex][itemName]}
        </Cell>
    );
};

class Bookings extends Component {
    constructor(props) {
        super(props);

        this.state = {
            columnWidths: {
                status: 0.13,
                locator: 0.1,
                sellTime: 0.15,
                destiny: 0.1,
                email: 0.2,
                phone: 0.12,
                name: 0.2
            }
        };

        this.resizeCallback = this.resizeCallback.bind(this);
    };

    resizeCallback(newWidth, columnKey) {
        this.setState(({columnWidths}) => ({
            columnWidths: {
                ...columnWidths,
                [columnKey]: newWidth / this.props.containerWidth
            }
        }));
    };

    render() {
        const tableData = this.props.tableData;
        const cw = this.props.containerWidth;
        const columnWidths = this.state.columnWidths;

        return (
            <Table
                rowHeight={50}
                headerHeight={50}
                rowsCount={tableData.length}
                width={cw}
                height={500}
                onColumnResizeEndCallback={this.resizeCallback}
                isColumnResizing={false}>
                <Column
                    columnKey="status"
                    header={<Cell>Status</Cell>}
                    cell={<BookingCell data={tableData} itemName="status"/>}
                    width={cw * columnWidths.locator}
                    minWidth={20}
                    isResizable={true}
                />
                <Column
                    columnKey="locator"
                    header={<Cell>Localizador</Cell>}
                    cell={<BookingCell data={tableData} itemName="locator"/>}
                    width={cw * columnWidths.locator}
                    minWidth={20}
                    isResizable={true}
                />
                <Column
                    columnKey="selltime"
                    header={<Cell>Data da Compra</Cell>}
                    cell={<BookingCell data={tableData} itemName="sellTime"/>}
                    width={cw * columnWidths.sellTime}
                    minWidth={20}
                    isResizable={true}
                />
                <Column
                    columnKey="address"
                    header={<Cell>Endereço</Cell>}
                    cell={<BookingCell data={tableData} itemName="address"/>}
                    width={cw * 0.25}
                    minWidth={20}
                    isResizable={true}
                />
                <Column
                    columnKey="destiny"
                    header={<Cell>Destino</Cell>}
                    cell={<BookingCell data={tableData} itemName="destiny"/>}
                    width={cw * columnWidths.destiny}
                    minWidth={20}
                    isResizable={true}
                />
                <Column
                    columnKey="email"
                    header={<Cell>Email</Cell>}
                    cell={<BookingCell data={tableData} itemName="email"/>}
                    width={cw * columnWidths.email}
                    minWidth={20}
                    isResizable={true}
                />
                <Column
                    columnKey="findUs"
                    header={<Cell>Canal</Cell>}
                    cell={<BookingCell data={tableData} itemName="findUs"/>}
                    width={cw * columnWidths.email}
                    minWidth={20}
                    isResizable={true}
                />
                <Column
                    columnKey="phone"
                    header={<Cell>Telefone</Cell>}
                    cell={<BookingCell data={tableData} itemName="phone"/>}
                    width={cw * columnWidths.phone}
                    minWidth={20}
                    isResizable={true}
                />
                <Column
                    columnKey="name"
                    header={<Cell>Nome</Cell>}
                    cell={<BookingCell data={tableData} itemName="name"/>}
                    width={cw * columnWidths.name}
                    minWidth={20}
                    isResizable={true}
                />
                <Column
                    columnKey="sourceCode"
                    header={<Cell>Source Code</Cell>}
                    cell={<BookingCell data={tableData} itemName="sourceCode"/>}
                    width={cw * columnWidths.locator}
                    minWidth={20}
                    isResizable={true}
                />

                <Column
                    columnKey="totalFare"
                    header={<Cell>Tarifa</Cell>}
                    cell={<BookingCell data={tableData} itemName="totalFare"/>}
                    width={cw * columnWidths.locator}
                    minWidth={20}
                    isResizable={true}
                />
                <Column
                    columnKey="totalFee"
                    header={<Cell>Fee</Cell>}
                    cell={<BookingCell data={tableData} itemName="totalFee"/>}
                    width={cw * columnWidths.locator}
                    minWidth={20}
                    isResizable={true}
                />
                <Column
                    columnKey="tax"
                    header={<Cell>Taxa</Cell>}
                    cell={<BookingCell data={tableData} itemName="tax"/>}
                    width={cw * columnWidths.locator}
                    minWidth={20}
                    isResizable={true}
                />
                <Column
                    columnKey="total"
                    header={<Cell>Total</Cell>}
                    cell={<BookingCell data={tableData} itemName="total"/>}
                    width={cw * columnWidths.locator}
                    minWidth={20}
                    isResizable={true}
                />


            </Table>
        );
    };
}
;

export default Dimensions({
    getHeight: function (element) {
        return window.innerHeight - 200;
    },
    getWidth: function (element) {
        var widthOffset = window.innerWidth < 768 ? 62 : 286;
        return window.innerWidth - widthOffset;
    }
})(Bookings);



// WEBPACK FOOTER //
// ./src/components/Bookings/index.js